var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.726995
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.610352,
    y: 0.609863,
    width: 40,
    height: 45,
    rx: 4,
    fill: "url(#paint0_linear_2633_7707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.48 24.5493L11.5261 23.5954C11.1222 23.1915 11.1222 22.5383 11.5261 22.1387L19.8749 13.7856C20.2788 13.3817 20.9319 13.3817 21.3315 13.7856L29.6804 22.1344C30.0843 22.5383 30.0843 23.1915 29.6804 23.5911L28.7265 24.545C28.3183 24.9532 27.6522 24.9446 27.2526 24.5278L22.3241 19.3543V31.7036C22.3241 32.275 21.8644 32.7348 21.2929 32.7348H19.9179C19.3464 32.7348 18.8866 32.275 18.8866 31.7036V19.3543L13.9538 24.5321C13.5542 24.9532 12.8882 24.9618 12.48 24.5493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_7707",
    x1: 35.4644,
    y1: 60.5093,
    x2: -14.1583,
    y2: 43.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollUp);
export default __webpack_public_path__ + "static/media/scrollUp.6980d3ddf0826a6465ffc895aedef040.svg";
export { ForwardRef as ReactComponent };